import { useSelector } from "react-redux";

import { FreshpaintState } from "../reducers";
import { LocalStorageProject } from "../reducers/environments";

const useCurrentProject = () => {
  return useSelector((state: FreshpaintState):
    | { loaded: false }
    | ({ loaded: true } & LocalStorageProject) => {
    const project = state.environments.currentEnvironment?.project;
    const loaded = state.environments.loaded;
    if (loaded && project) {
      return {
        ...project,
        loaded,
      };
    } else {
      return { loaded: false };
    }
  });
};

export default useCurrentProject;
